var render = function render(){var _vm=this,_c=_vm._self._c;return _c('taskyType',{attrs:{"type":6}})
}
var staticRenderFns = []

export { render, staticRenderFns }